export default "__VITE_ASSET__GVq6$Vz2__"